import { DialogComponent } from "./chunk-3YPFY763.js";
import { __objRest, __spreadProps, __spreadValues } from "./chunk-ORMEWXMH.js";

// src/components/Drawer/Drawer.tsx
import clsx from "clsx";
import { jsx, jsxs } from "react/jsx-runtime";
var Drawer = _a => {
  var _b = _a,
    {
      isOpen,
      onClose,
      children,
      title,
      dismissLabel,
      position = "left",
      className
    } = _b,
    rest = __objRest(_b, ["isOpen", "onClose", "children", "title", "dismissLabel", "position", "className"]);
  const isLeft = position === "left";
  return /* @__PURE__ */jsxs(DialogComponent, __spreadProps(__spreadValues({
    isOpen,
    onClose,
    className: clsx("pd:drawer", className)
  }, rest), {
    children: [/* @__PURE__ */jsx(DialogComponent.Backdrop, {}), /* @__PURE__ */jsx(DialogComponent.Front, {
      children: /* @__PURE__ */jsxs(DialogComponent.Panel, {
        transition: isLeft ? "slide-from-left-full" : "slide-from-right-full",
        className: clsx("pd:pointer-events-auto pd:absolute pd:inset-y-0 pd:w-4/5 pd:max-w-[25rem]", isLeft ? "pd:left-0" : "pd:right-0"),
        children: [title && dismissLabel && /* @__PURE__ */jsx(DialogComponent.Header, {
          title,
          variant: "primary",
          dismissLabel
        }), title ? /* @__PURE__ */jsx(DialogComponent.Content, {
          children
        }) : children]
      })
    })]
  }));
};
var Drawer_default = Drawer;
export { Drawer_default };